import axios from 'axios'
const token = localStorage.getItem('token')
const instance = axios.create({
  baseURL: `http://222.255.100.41:3000/`,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    "Access-Control-Allow-Origin": "*",
    'Authorization': 'jwt ' + token
  }
}
)

export default instance 